<template>
<div class="mission-container ">
  <div class="card card-body p-2">
  <AsdecodeTable class="mb-4" :columns="columns" url="/api/projets" table="projets" @set-total-records="updateLines"
        @row-click="showLine" @set-selected-rows="getSelection">

        <!-- Modifier l'affichage par defaut d'une colonne -->
        <template #created_at="slotProps">
            <span class="p-2 rounded badge badge-secondary">{{ slotProps.data.created_at }}</span>
        </template>
    </AsdecodeTable>
</div>
  <div class="d-flex justify-content-end">
    <button class="btn btn-primary rounded-pill" @click.prevent="showCreateModal">
      <i class="fas fa-plus me-1"></i> Ajouter une mission
    </button>
  </div>
  <div class="mt-3">
    <p v-if="lines === 0" class="text-center">Aucune mission trouvée.</p>
    <p v-else class="text-center">Total des missions : {{ lines }}</p>
  </div>
</div>
</template>

<script>
import { defineComponent } from 'vue';
import FormMission from './ReplyMission.vue';
import ShowMission from './ShowMission.vue';

export default defineComponent({
    name: 'IndexMission',

    data() {
        return {
            lines: 0,
            selection: [],
            columns: [
                {
                    key: 'nom',
                    label: 'Nom',
                },
                {
                    key: 'description',
                    label: 'Description',
                },
                {
                    key: 'created_at',
                    label: 'Ajouté le',
                }
            ]
        }
    },
    methods: {
        logout() {
            // Rediriger vers le tableau de bord
            if (this.$router.push({ name: 'login' })) {
                // Effacer les données utilisateur
                this.$store.commit('clearUserData')
            }
        },
        showLine(line) {
            this.$dialog.open(ShowMission, {
                props: {
                    header: 'Mission ' + line.id,
                    style: { width: '50vw' },
                    modal: true,
                },
                data: line
            });
        },
        updateLines(nb) {
            this.lines = nb
        },
        showCreateModal() {
            this.$dialog.open(FormMission, {
                props: {
                    header: 'Ajouter un Mission',
                    style: { width: '50vw' },
                    modal: true,
                },

            });
        },

    },
});
</script>

<style scoped>
.mission-container {
  max-width: 1200px;
  margin: 0 auto;
}

</style>